module.exports = __webpack_public_path__ + "img/WX20190929-210022@2x.01ee71a2.png";